module.exports = __webpack_public_path__ + "static/media/71VjM5LOeYL._AC_UX569_.5f07f103.jpg";